/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import type { GlyphName } from '@remind/r101-glyphs';
import TextWithEntities from 'components/TextWithEntities.jsx';
import TextEntities from 'lib/TextEntities';
import getPropClasses from 'lib/getPropClasses';
import Text from 'components/Text.jsx';
import invariant from 'invariant';

import './styles/Notice.scss';

export type Props = {
  color?: 'shamrock' | 'lava' | 'pitch',
  glyph?: GlyphName,
  children?: any,
};

const propsToClasses = {
  color: {
    lava: 'Notice--lava',
    pitch: 'Notice--pitch',
    flame: 'Notice--flame',
    shamrock: 'Notice--shamrock',
  },
};

class Notice extends React.Component {
  props: Props;

  static defaultProps = {
    color: 'pitch',
  };

  render() {
    const { children, color, glyph } = this.props;

    invariant(children, 'Notice needs a children to render');
    const rootClasses = cx('Notice', getPropClasses(this.props, propsToClasses));

    return (
      <div className={rootClasses}>
        {glyph && <Glyph name={glyph} color={color} size="xsmall" solo className="Notice-glyph" />}
        <Text color="white" size="small" weight="semibold" className="Notice-text">
          <TextWithEntities
            text={children}
            entities={TextEntities.parseEmoji(children)}
          />
        </Text>
      </div>
    );
  }
}

export default Notice;



// WEBPACK FOOTER //
// ./src/components/Notice.jsx